/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brin_Api_Errors_Duplicate_SchoolInputs */

const nl_brin_api_errors_duplicate_school = /** @type {(inputs: Brin_Api_Errors_Duplicate_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze school is al geregistreerd.`)
};

/**

* @param {Brin_Api_Errors_Duplicate_SchoolInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const brin_api_errors_duplicate_school = /** @type {((inputs?: Brin_Api_Errors_Duplicate_SchoolInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brin_Api_Errors_Duplicate_SchoolInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_brin_api_errors_duplicate_school(inputs)
});
export { brin_api_errors_duplicate_school as "brin.api_errors.duplicate_school" }